import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';


export const GroupedMenuItem = (props) => {
	const {
		children,
		disabled,
		className,
		onClick,
		...otherProps
	} = props;

	return (
		<div
			role="button"
			onClick={onClick}
			onKeyUp={onClick}
			className={classNames(className, 'ads-grouped-menu-item', disabled ? 'ads-disabled' : '')}
			tabIndex={0}
			disabled
			{...otherProps}
		>
			{children}
		</div>
	);
}

GroupedMenuItem.propTypes = {
	disabled: PropTypes.bool,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

GroupedMenuItem.defaultProps = {
	disabled: false,
	className: '',
	onClick: null,
};
